import { OnInit, PLATFORM_ID, Inject,Component } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserDeviceConstant, CacheConstant } from './core/constants/app.constant';
import { Footer } from './shared/models/footer';

import { MajorFooter } from './core/constants/major-footer.constant';
import { ParmedFooter } from './core/constants/parmed-footer.constant';
import { AppCacheService } from './core/services/cache/app-cache.service';
import { AppConfigService } from './core/services/init/app-config.service';
@Component({
  template: ''
})
export abstract class BaseComponent implements OnInit {

  /***************Properties***************/
  websiteName: string;
  entity: string;
  public footerData : Footer;
  /***************Properties***************/

  /***************Constructor***************/
  constructor( private deviceDetectorService: DeviceDetectorService, private appCacheService: AppCacheService, public appConfigService: AppConfigService) {
   this.appConfigService.isConfigLoaded.subscribe(res=>{
     if(res){
       this.websiteName = this.appCacheService.get(CacheConstant.Env_Properties).theme;
       this.entity =  `${this.websiteName +'Footer'}`;
      this.entity === 'ParmedFooter' ? this.footerData = ParmedFooter : this.footerData = MajorFooter;
     }
   })
  }


  ngOnInit(): void {}
  /***************Constructor***************/

  /******************Component Methods******************/

  isMobileDevice() {
    return this.getDeviceName() === UserDeviceConstant.Mobile;
  }

  isDesktopDevice() {
    return this.getDeviceName() === UserDeviceConstant.Desktop;
  }
  isTabletDevice(){
       return this.getDeviceName() === UserDeviceConstant.Tablet; 
  }

  getFooterData() {
    return this.footerData;
  }

  /******************Component Methods******************/

  /******************Private Methods******************/

  private getDeviceName(): UserDeviceConstant {
    return this.deviceDetectorService.isDesktop()
      ? UserDeviceConstant.Desktop
      : this.deviceDetectorService.isTablet()
        ? UserDeviceConstant.Tablet
        : UserDeviceConstant.Mobile;
  }

  /******************Private Methods******************/
}
